import { useTranslation } from 'next-i18next';

import { Button, Typography } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import CheckMarkWithoutBG from '~/images/shared/CheckMarkWithoutBG.svg';

const JobAddedSuccess = () => {
  const { t } = useTranslation();

  const { closeModal } = useModal();

  return (
    <div className='flex flex-col items-center gap-32'>
      <div className='flex h-64 w-64 items-center justify-center rounded-full bg-secondary-90 text-green-300'>
        <CheckMarkWithoutBG width='30' height='30' />
      </div>
      <div className='text-center'>
        <Typography variant='h2' weight='medium' className='mb-8'>
          {t('Jobs successfully added!')}
        </Typography>
        <Typography className='text-surface-10'>
          {t('You can now use these jobs in your fields')}
        </Typography>
      </div>
      <Button onClick={() => closeModal()} className='h-56 !w-full !rounded-xl'>
        {t('Dismiss')}
      </Button>
    </div>
  );
};

export { JobAddedSuccess };
